import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles(theme => ({
  dialog: {
    backgroundColor: theme.palette.gray.dark,
    borderRadius: theme.spacing(2),
    boxShadow: 'inset -1px -1px 8px 0px rgba(0,0,0,0.04)',
  },
  title: {
    ...theme.typography.h1,
    fontFamily: theme.typography.secondaryFontFamily,
    flexDirection: 'column',
    display: 'flex',
    alignItems: 'center',
  },
}));
